import { defaultRender } from '../utils';
/**
 * The default layout only rendering the provided children.
 */
export const DefaultLayout = ({ children }) => defaultRender(children);
DefaultLayout.displayName = 'DefaultLayout';
//# sourceMappingURL=DefaultLayout.js.map